import $ from 'jquery'

// Ao destruir um componente, não iniciar uma animação hide em um nó que o Vue
// removerá. Dispose remove o backdrop pertencente à instância, sem atingir outros.
export function destruirModalBootstrap(element, { aberto, pronto, namespace }) {
  if (!element) return
  const modal = $(element), cleanup = namespace + 'Cleanup'
  modal.off('.' + namespace)
  element.setAttribute('data-editing-retained', 'true')
  const limpar = () => {
    modal.off('.' + cleanup).modal('dispose')
    element.remove()
    document.body.classList.toggle('modal-open', !!document.querySelector('.modal.show'))
  }
  if (!aberto || (pronto && element.classList.contains('show'))) limpar()
  else modal.one(`${pronto ? 'hidden' : 'shown'}.bs.modal.${cleanup}`, limpar)
}
